import React from 'react';
import { Col } from 'reactstrap';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import SelectInputTranslated from 'components/layout/forms/SelectInputTranslated';
import translations from 'services/translations/translations';

import glassTypes, {
  glassTypesByWallTypes,
} from 'components/configurator/types/glassTypes';

import {
  is2kAluGlazy,
  is2kTypeWall,
  isSlidy30,
  isSlidy36,
} from 'components/configurator/types/glazingWallTypesCheck';

import {
  ALU_2K_GLAZY,
  TWO_K_TYPE,
  SLIDY_30,
  SLIDY_36,
} from 'components/configurator/types/glazingWallTypes';

import handleGlassWallProperties from '../handleGlassWallProperties';

const GlassType = ({
  disableInputs,
}: {
  disableInputs?: boolean;
}): JSX.Element => {
  const wall = useSelector((state: any) => state.selectedWall.properties);
  const { t } = useTranslation([translations.glassWallProperties]);

  const getGlassTypes = () => {
    if (is2kAluGlazy(wall)) {
      return glassTypesByWallTypes[ALU_2K_GLAZY];
    }

    if (is2kTypeWall(wall)) {
      return glassTypesByWallTypes[TWO_K_TYPE];
    }

    if (isSlidy30(wall)) {
      return glassTypesByWallTypes[SLIDY_30];
    }

    if (isSlidy36(wall)) {
      return glassTypesByWallTypes[SLIDY_36];
    }

    return glassTypes;
  };

  const name = 'glassType';

  return (
    <Col>
      <SelectInputTranslated
        className="edit-fields"
        disabled={disableInputs}
        id={name}
        label={t(`${translations.glassWallProperties}:fields:Glass Type`)}
        name={name}
        onChange={handleGlassWallProperties}
        optionKeyBase={`glass-wall-field-${name}`}
        options={getGlassTypes()}
        required
        translationPath={`${translations.glassWallProperties}:measurements`}
        value={wall.glassType}
      />
    </Col>
  );
};

export default GlassType;
